import React, { Fragment } from 'react'
import { useQuotation2, Quotation2Props } from './useQuotation2'
import styles from './Quotation2.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'
import QuotationCard from 'components/QuotationCard/QuotationCard'
import AnimatedContainer from 'components/AnimatedContainer/AnimatedContainer'

const Quotation2: React.FC<Quotation2Props> = (props: Quotation2Props) => {
  const { quotationsData, isAr, t } = useQuotation2(props)

  return quotationsData && quotationsData.length > 1 ? (
    <section id='quotation2' className={styles.quotation2}>
      <TitleSection title={t('quotation')} />
      <div className='container'>
        <div className='row'>
          <div key={`quotation-${quotationsData[1].id}`} className='col-12'>
            <AnimatedContainer animation='jackInTheBox' extraCssClasses='h-100'>
              <QuotationCard
                title={
                  isAr ? quotationsData[1].titleAr : quotationsData[1].titleEn
                }
                description={
                  isAr
                    ? quotationsData[1].descriptionAr
                    : quotationsData[1].descriptionEn
                }
              />
            </AnimatedContainer>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <Fragment />
  )
}

export default Quotation2
